"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOrderNumber = exports.extractCounter = exports.formatOrderNumber = exports.getShortVersion = exports.ORDER_COUNTER_KEY = void 0;
const format_1 = __importDefault(require("date-fns/format"));
const react_1 = require("react");
exports.ORDER_COUNTER_KEY = 'orderCounter';
function getShortVersion(orderNumber) {
    if (orderNumber && typeof orderNumber === 'string') {
        return orderNumber.split('-').slice(0, -1).join('-');
    }
    return '';
}
exports.getShortVersion = getShortVersion;
// extract from SP-72-2-20220729 to 72-2
function formatOrderNumber(orderNumber) {
    if (orderNumber) {
        const splitOrderNumber = orderNumber.split('-');
        let value = splitOrderNumber[2];
        const prefix = splitOrderNumber[0] + '-' + splitOrderNumber[1];
        if (splitOrderNumber.length == 5) {
            value = `${value}-${splitOrderNumber[4]}`;
        }
        return `${prefix}-${value}`;
    }
    return orderNumber;
}
exports.formatOrderNumber = formatOrderNumber;
function extractCounter(orderNumber) {
    if (orderNumber && typeof orderNumber === 'string') {
        const value = orderNumber.split('-').slice(-2, -1)[0];
        return value ? +value : 0;
    }
    return 0;
}
exports.extractCounter = extractCounter;
function useOrderNumber(salesPrefix, storage) {
    const generate = (0, react_1.useCallback)(async () => {
        const prefix = salesPrefix || '';
        const date = (0, format_1.default)(new Date(), 'yyyyMMdd');
        const latestOrderCounter = ((await storage.getItem(exports.ORDER_COUNTER_KEY)) || 0) + 1;
        return `${prefix}-${latestOrderCounter}-${date}`;
    }, [salesPrefix]);
    const setOrderCounter = (0, react_1.useCallback)(async (lastOrderNumber) => {
        if (lastOrderNumber) {
            await storage.setItem(exports.ORDER_COUNTER_KEY, extractCounter(lastOrderNumber));
        }
        else {
            await storage.setItem(exports.ORDER_COUNTER_KEY, 0);
        }
    }, []);
    return { generate, setOrderCounter };
}
exports.useOrderNumber = useOrderNumber;
//# sourceMappingURL=useOrderNumber.js.map